<template>
  <div class="frame_greeting">
    <p class="balloon greeting_balloon">はじめまして！</p>
    <img class="greeting_photo" src="/assets/img/home/greeting/img_pc_greet_01.png" alt="朝山　哲夫">
    <p class="about_doctor greeting_about_doctor">
      <span class="clinic_name">{{ clinic_name }}</span><span class="clinic_post">{{ post }}</span><br>
      <span class="doctor_name">{{ doctor }}</span>
    </p>
    <div class="perspective">
      <div id="perspective001" class="perspective_bg bg_001"><img src="/assets/img/home/greeting/bg_pc_greet_01.png" alt=""></div>
      <div id="perspective002" class="perspective_bg bg_002"><img src="/assets/img/home/greeting/bg_pc_greet_02.png" alt=""></div>
      <div id="perspective101" class="perspective_img img_001"><img src="/assets/img/home/greeting/img_pc_greet_02.png" alt=""></div>
      <div id="perspective102" class="perspective_img img_002"><img src="/assets/img/home/greeting/img_pc_greet_03.png" alt=""></div>
      <div id="perspective103" class="perspective_img img_003"><img src="/assets/img/home/greeting/img_pc_greet_04.png" alt=""></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Greeting',
  props: {
    msg: String,
    clinic_name: String,
    doctor: String,
    post: String
  },
  computed: {
    ...mapState([
      'isMobile'
    ])
  },
  mounted () {
    const isMobile = this.isMobile
    const $perspectives = this.$el.querySelectorAll('.perspective div')
    const pRate = [1, 0.95, 0.5, 0.45, 0.4]
    const eventName = isMobile ? 'deviceorientation' : 'mousemove'
    const date = new Date()
    if (isMobile && ![4, 5, 6, 7, 8].includes(date.getMonth())) {
      window.addEventListener('deviceorientation', function(e){
        if (Math.floor(e.timeStamp)%3 != 0) {
          return false;
        }
        const transrate = {};
        // gamma スマホy軸回転
        // beta  スマホx軸回転
        transrate.x = Math.abs(e.gamma) < 15 ? Math.floor(e.gamma) : Math.sign(e.gamma)*15;
        transrate.y = Math.abs(e.beta-45) < 15 ? Math.floor(e.beta-45) : Math.sign(e.beta-45)*15;
        Array.prototype.forEach.call($perspectives, (function(ele, idx){
          ele.style.transform = 'translate(' + transrate.x * pRate[idx] + 'px, ' + transrate.y * pRate[idx] + 'px)'
        }));
      });
    } else if (!isMobile) {
      window.addEventListener('mousemove', function(e){
        const transrate = {};
        transrate.x = Math.floor(e.pageX / 50);
        transrate.y = Math.floor(e.pageY / 50);
        Array.prototype.forEach.call($perspectives, (function(ele, idx){
          ele.style.transform = 'translate(' + transrate.x * pRate[idx] + 'px, ' + transrate.y * pRate[idx] + 'px)'
        }));
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
